import createSource from 'utils/createSource';
import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import {dashboardApi} from './api';
import urlWithParams from 'utils/urlWithParams';

// This isn't great but getting the proper state to derive this
// everywhere its needed would be painful
export function shouldApplyDeptFilter() {
  const path = window.location.pathname;
  const isAdmin = path.includes('/dashv2/admin/');
  const isManager = path.includes('/manager/');
  return isAdmin && !isManager;
}

/**
 * Interactions with /dashboard api
 */
const ManagerDashboardSource = {
  getScoredCallIds: {
    remote(scoredCallsQuery) {
      const options = {...scoredCallsQuery};
      const url = urlWithParams('scored_call_ids', {});
      return dashboardApi.postJson(url, options);
    },
    error: ManagerDashboardActions.getScoredCallIdsError,
    success: ManagerDashboardActions.getScoredCallIdsSuccess,
  },

  getWidget: {
    remote([widgetConfig, managerId]) {
      if (managerId) {
        const url = urlWithParams('/widget', {managerId});
        return dashboardApi.postJson(url, widgetConfig, {
          params: {deptFilter: shouldApplyDeptFilter()},
        });
      } else {
        return dashboardApi.postJson('/widget', widgetConfig, {
          params: {deptFilter: shouldApplyDeptFilter()},
        });
      }
    },
    error: ManagerDashboardActions.getWidgetError,
    success: ManagerDashboardActions.getWidgetSuccess,
  },
};

export default createSource(ManagerDashboardSource);
